module.exports = __webpack_public_path__ + "img/incomplete.bf8279d0.svg";